import service from "@/utils/request"

export function getCheckInListApi(data) {
    return service({
        url: '/check-in/getPage',
        method: 'get',
        params:data
    })
}

export function passOrRejectApi(data) {
    return service({
        url: '/check-in/passOrReject',
        method: 'post',
        data
    })
}


export function checkInAddApi(data) {
    return service({
        url: '/check-in/add',
        method: 'post',
        data
    })
}